import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { Container } from "./style";

export function ErrorAlert({ message }: { message: string }) {
    return (
        <Container>
            <FontAwesomeIcon
                icon={faCircleExclamation}
                style={{ marginRight: '10px', fontSize: '20px' }} />
            <p>{message}</p>
        </Container>
    );
}
